module.exports = __webpack_public_path__ + "static/media/kitty-love-1.0de7df27.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/images/home-page/kitty-love-1.svg
// module id = 128
// module chunks = 0